// 订单充电过程
import React, { Component } from "react";
import "@/assets/stylus/com/display/process.styl";
import PropsType from "prop-types";

// 引用的组件
import HistoryStubInfo from "./historyStubInfo";
class ModuleDetail extends Component {
  constructor(props) {
    super(props);
    this.init();
    this.props = props;
    this.state = {
      currentPhase: "stub",
    };
  }

  init() {}

  componentWillMount() {
    this.query = {};
    if (window.LayoutTab && window.LayoutTab.tabParam) {
      this.query["sn"] = window.LayoutTab.tabParam.sn;
    }
    this.getStubDetail();
  }

  // 获取模块基础详情
  getStubDetail() {
    console.log(this.props);
    this.setState({
      sn: this.query.sn,
    });
  }

  handleModuleTypeChange = (e) => {
    this.setState({
      currentPhase: e.target.value,
    });
  };

  render() {
    const Content = (
      <div className="sc-page-content">
        <div className="innerTab">
          <HistoryStubInfo sn={this.state.sn} onAdd={this.props.onAdd} />
        </div>
      </div>
    );
    return Content;
  }
}

export default ModuleDetail;

ModuleDetail.propsType = {
  onAdd: PropsType.func,
};



// WEBPACK FOOTER //
// ./src/AntD/pages/configurationManagement/module/moduleDetail.js